// Total de l'encadré « Économies estimées » de la fiche client (ClientDetailPage).
// - Acheminement : best_saving_eur est déjà une économie POSITIVE.
// - Taxes : un résumé ERA est NÉGATIF quand le client est remboursé (K + N, voir
//   remboursementEra.js) ; on l'inverse pour l'exprimer en économie. Un ERA positif (accise
//   due par le client) diminue donc le total.
// Avant le 04/11/2026 les deux étaient additionnés tels quels : le remboursement CSPE était
// affiché en négatif et venait en déduction des économies d'acheminement.
import { regularisationTotaleEra } from './remboursementEra';

export function economiesEstimees(acheminementResults, taxesAnalysisResults) {
  const achem = Object.values(acheminementResults || {})
    .reduce((sum, r) => sum + (Number(r?.best_saving_eur) || 0), 0);
  const taxes = Object.values(taxesAnalysisResults || {})
    .reduce((sum, r) => sum - regularisationTotaleEra(r), 0);
  return achem + taxes;
}
